<template>
  <div id="StepWizardHandler" class="container-fluid">
    <div v-show="isFinishing">
      <astronaut></astronaut>
    </div>
    <div v-show="isLoading">
      <loading :text="'Vamos começar a criar conteúdo para seu site'"></loading>
    </div>
    <WizardNavbar
      @trigger-back-step="triggerBackStep()"
      @nextStep="nextStep"
      :isThemeStep="checkIfIsTheme"
    />
    <div class="conainer step-content">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8" v-if="validateStepWizardParameter()">
          <component
            :orientation="orientation"
            :is="stepWizard"
            :stepName="getStepName"
            :stepDirt="getStepDirtValue"
            @updateStep="updateStep"
            @nextStep="nextStep"
            @trigger-back-step="triggerBackStep()"
          ></component>
        </div>
      </div>
      <div
        class="row fixed-bottom justify-content-center"
        v-if="verifyBottomButtons"
      >
        <div class="col-auto" v-if="verifySkip">
          <button class="btn btn-extra-large btn-skip" @click="nextStep">
            Pular
          </button>
        </div>
        <div class="col-auto text-center">
          <button
            class="btn btn-primario btn-extra-large"
            @click="nextStep"
            :disabled="verifyDisabled"
          >
            Continuar
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Astronaut from "@/components/Astronaut";
import Loading from "@/components/Loading";
import StepWizardAbout from "@/components/organisms/StepWizardAbout";
import StepWizardBlog from "@/components/organisms/StepWizardBlog";
import StepWizardCommercialName from "@/components/organisms/StepWizardCommercialName";
import StepWizardContact from "@/components/organisms/StepWizardContact";
import StepWizardHighlight from "@/components/organisms/StepWizardHighlight";
import StepWizardIntegrations from "@/components/organisms/StepWizardIntegrations";
import StepWizardLogoConfig from "@/components/organisms/StepWizardLogoConfig";
import StepWizardNovidades from "@/components/organisms/StepWizardNovidades";
import StepWizardPortfolio from "@/components/organisms/StepWizardPortfolio";
import StepWizardSegments from "@/components/organisms/StepWizardSegments";
import StepWizardServicos from "@/components/organisms/StepWizardServicos";
import StepWizardSloganHome from "@/components/organisms/StepWizardSloganHome";
import StepWizardTestimony from "@/components/organisms/StepWizardTestimony";
import StepWizardThemes from "@/components/organisms/StepWizardThemes";
import StepWizardWhatsapp from "@/components/organisms/StepWizardWhatsapp";
import WizardNavbar from "@/components/molecules/WizardNavbar";
export default {
  name: "StepWizardHandler",
  data() {
    return {
      components: [],
      orientation: null,
    };
  },
  props: {
    stepWizard: {
      required: true,
      default: "StepWizardIntegrations",
    },
  },
  components: {
    Astronaut,
    Loading,
    StepWizardAbout,
    StepWizardBlog,
    StepWizardCommercialName,
    StepWizardContact,
    StepWizardHighlight,
    StepWizardIntegrations,
    StepWizardLogoConfig,
    StepWizardNovidades,
    StepWizardPortfolio,
    StepWizardSegments,
    StepWizardServicos,
    StepWizardSloganHome,
    StepWizardTestimony,
    StepWizardThemes,
    StepWizardWhatsapp,
    WizardNavbar,
  },
  async created() {
    this.components = this.$store.state.wizard.components;
    let validParameter = await this.validateStepWizardParameter();
    if (this.stepWizard != "StepWizardIntegrations") {
      this.$router.push({
        name: "StepWizard",
        params: { stepWizard: "StepWizardIntegrations" },
      });
    }
    this.$store.dispatch("WIZARD_START_DATE");
  },
  methods: {
    validateStepWizardParameter() {
      return this.components.some(
        (component) => component.step == this.stepWizard
      );
    },
    getActiveIndexStepByParameter() {
      let defaultStep = 0;
      let existentStep = this.components.findIndex(
        (component) => component.step == this.stepWizard
      );
      return existentStep >= 0 ? existentStep : defaultStep;
    },
    checkStep(index) {
      if (this.$store.state.wizard.step == index) {
        return true;
      } else {
        return false;
      }
    },
    async getAboutAi() {
      this.$store.dispatch("TOGGLE_LOADING", [true]);
      //wizard: this.$store.state.wizard.dataSite,
      const token = this.$session.get("jwt");
      const siteId = this.$session.get("siteId");
      await axios({
        method: "post",
        url: `${process.env.ROOT_API}/api/about/ai`,
        data: {
          wizard: this.$store.state.wizard.dataSite,
          components: this.$store.state.wizard.components
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      })
        .then((result) => {
          this.API_CALL_IN_PROGRESS = false;
          console.log('then', result);
          if (result.data) {
            var aboutList = this.$store.state.wizard.dataSite.aboutSetup.aboutList;
            console.log('aboutList: ', aboutList)
            var newArray = result.data;
            console.log('newarray', newArray);
            var newAboutList = aboutList.unshift(newArray);
            this.$store.dispatch("UPDATE_ABOUT_LIST", newAboutList);
            return result;
          }
        })
        .catch((response) => {
          console.log('response', response);
          this.API_CALL_IN_PROGRESS = false;
          return response;
        });
    },
    normalizeUrl(item) {
        // Verifica se a URL já começa com process.env.CDN_URL
        if (item.startsWith(process.env.CDN_URL)) {
            return item;
        }
				return `${process.env.CDN_URL}${item}`;
		},
    upscaleImages(files) {
				let token = this.$session.get("jwt");
				let siteId = this.$session.get("siteId");

				// coloca a url da cnd para enviar para a api fazer upscale
				for (let i = 0; i < files.length; i++) {
					files[i].mainImage = this.normalizeUrl(files[i].mainImage);
				}

				axios({
					method: "post",
					url: `${process.env.ROOT_API}/api/site/${siteId}/wizard/highlights/upscale`,
					data: {files : files},
					headers: {
					Authorization: "Bearer " + token,
					"Content-Type": "application/json"
					}
				}).then(response => {
					console.log('response')
					console.log(response);
				})
				.catch(error => {
					console.error('error');
					console.error(error);
				});
		},
    async nextStep(buttonJump) {
      this.orientation = "foward";

      const stepName = this.components[this.getActiveIndexStepByParameter()].title;

      console.log('component', stepName);
      if (stepName == 'Nome do site') {
        await this.getAboutAi();
      } else if (stepName == 'Home') {
        this.upscaleImages(this.$store.state.wizard.dataSite.highlights)
      }

      let index = this.getActiveIndexStepByParameter();
      if (index < this.components.length - 1) {
        let nextComponent = this.components[++index].step;
        this.pushNextComponent(nextComponent, buttonJump);
      } else {
        this.$store.dispatch("WIZARD_SEND_WIZARD");
      }
    },
    triggerBackStep() {
      this.orientation = "backward";
      let index = this.getActiveIndexStepByParameter();
      let nextComponent = this.components[--index].step;
      this.pushNextComponent(nextComponent);
    },
    pushNextComponent(nextComponent, buttonJump) {
      this.$router.push({
        name: "StepWizard",
        params: { stepWizard: nextComponent, buttonJump: buttonJump },
      });
    },
    disableContinueButton() {
      this.$store.dispatch("WIZARD_BLOCK_NEXT", [true]);
    },
    updateStep() {
      const activeItemIndex = this.getActiveIndexStepByParameter();
      this.$store.dispatch("WIZARD_UPDATE_STEP", [activeItemIndex]);
    },
  },
  computed: {
    isLoading() {
      return this.$store.state.wizard.loading;
    },
    isFinishing() {
      return this.$store.state.wizard.finishing;
    },
    verifySkip() {
      return this.$store.state.wizard.bottomButtons.showSkip;
    },
    verifyBottomButtons() {
      return this.$store.state.wizard.bottomButtons.showBottomButtons;
    },
    verifyDisabled() {
      return this.$store.state.wizard.bottomButtons.blockNext;
    },
    getStepName() {
      let indexStep = this.getActiveIndexStepByParameter();
      return this.components[indexStep].title;
    },
    getStepDirtValue() {
      let indexStep = this.getActiveIndexStepByParameter();
      return this.components[indexStep].dirt;
    },
    checkIfIsTheme() {
      return this.stepWizard == "StepWizardThemes";
    },
    testStep() {
      return this.getActiveIndexStepByParameter();
    },
  },
  watch: {
    stepWizard() {
      this.disableContinueButton();
    },
  },
};
</script>
<style>
.step-content {
  padding: 5px 15px 90px 15px;
}
.step-content h4 {
  font-size: 1.5rem;
  line-height: 2.25rem;
  font-family: "Montserrat", sans-serif;
  margin-bottom: 32px;
}
.step-content label {
  font-size: 0.65rem;
  color: #cccccc;
  margin: 0;
  font-weight: 700;
}
.btn-skip {
  background-color: #ffffff;
  color: #b7b7b7;
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/StepWizardHandler.vue